export class VerifyEmail {
  email: string = '';
  token: string = '';
  set Email(value: string) {
    this.email = value;
  }

  get Email(): string {
    return this.email;
  }

  set Token(value: string) {
    this.token = value;
  }

  get Token(): string {
    return this.token;
  }
}
